import getLocale from "ati-core-utils/getLocale";
import { ILocaleStore } from "./Locale.types";
import { availableLocales } from "../../const";

class LocaleStore implements ILocaleStore {
    locale = getLocale(availableLocales, process.env.NODE_ENV);
}

export default LocaleStore;
